import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AppNotificationService } from '@core/services/app-notification.service';
import { AppUser, UserService } from '@core/services/user.service';
import { TenantApiService } from '@modules/bcm/@shared/services/api-services/tenant.api-service';
import { BcmService } from '@modules/bcm/bcm.service';
import { TranslationService } from '@core/translation/translation.service';

@Component({
    selector: 'read-privacy-and-conditions',
    templateUrl: './read-privacy-and-conditions.component.html',
    standalone: false
})
export class ReadPrivacyAndConditionsComponent {

    user: AppUser;

    isSaving: boolean;

    constructor(private _dialogRef: MatDialogRef<ReadPrivacyAndConditionsComponent>,
                private _appNotificationService: AppNotificationService,
                private _userService: UserService,
                private _tenantApiService: TenantApiService,
                private _bcmService: BcmService,
    ) {

        this._dialogRef.addPanelClass('default-dialog');
        this._dialogRef.disableClose = true;

        this.user = this._userService.user;
    }

    onClickDefer(): void {
        this._tenantApiService.deferConditions().subscribe((result) => {
            this._bcmService.tenant.conditions = result;
        }).add(() => {
            this._dialogRef.close(false);
        });
    }

    onClickOK(): void {
        this.isSaving = true;
        this._tenantApiService
            .confirmConditions()
            .subscribe((result) => {
                this._bcmService.tenant.conditions = result;
                this._appNotificationService.showSuccess(TranslationService.translate('bcm.privacyConditions.notify.confirmationSaved'));
            })
            .add(() => {
                this.isSaving = false;
                this._dialogRef.close(true);
            });
    }
}
